import { track } from "jiffy-analytics";
import EventClass from "common/utils/ui/event-class";
import DesignFileUploadingClass from "./design-file-uploading-class";

export default class DesignUploadCtaPLPFileUploadClass extends EventClass {
  #eventSelector;

  #props;

  constructor(props) {
    super(props);

    this.#eventSelector = props.eventSelector;
    this.#props = props;
  }

  emulateClick() {
    document.querySelector(this.#eventSelector).click();
  }

  event(event, $target) {
    super.event(event, $target);

    const { files } = event.target;
    if (files && files.length > 0) {
      const file = new DesignFileUploadingClass({
        file: files[0],
        triggerSource: "plp",
        ...this.#props
      });
      $target.value = ""; // Clear the input value to allow re-uploading the same file
      file.processFile();

      track("pdp_design_preview_upload_clicked", {
        target: "My Device"
      });
    }
  }
}
